import { render, staticRenderFns } from "./CaseSettings.vue?vue&type=template&id=aa9c1560&"
import script from "./CaseSettings.vue?vue&type=script&lang=js&"
export * from "./CaseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports